"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const convertCode_1 = require("./utils/convertCode");
const WeatherIcon = (_a) => {
    var { iconId, className = '', name, night = false } = _a, htmlProps = __rest(_a, ["iconId", "className", "name", "night"]);
    const iconClassName = convertCode_1.default(name, iconId, night);
    const classNames = `${iconClassName} ${className}`;
    return React.createElement("i", Object.assign({ className: classNames }, htmlProps, { "data-testid": "icon" }));
};
exports.default = WeatherIcon;
